import DefaultRangeTime from '@/Enums/DateTime/DefaultRangeTime.enum';
import type { DateRange } from '@mui/x-date-pickers-pro';
import type { Moment } from 'moment';

export const applyDefaultTimes = (range: DateRange<Moment>, prev: DateRange<Moment>): DateRange<Moment> => {
  let [startTime, endTime] = range;

  if (startTime) {
    const s = startTime.clone();
    const existingStartTime = prev[0];

    startTime = s
      .hours(existingStartTime ? existingStartTime.hours() : DefaultRangeTime.StartHour)
      .minutes(existingStartTime ? existingStartTime.minutes() : DefaultRangeTime.StartMin)
      .seconds(existingStartTime ? existingStartTime.seconds() : DefaultRangeTime.StartSec)
      .milliseconds(DefaultRangeTime.StartMs);
  }

  if (endTime) {
    const e = endTime.clone();
    const existingEndTime = prev[1];

    endTime = e
      .hours(existingEndTime ? existingEndTime.hours() : DefaultRangeTime.EndHour)
      .minutes(existingEndTime ? existingEndTime.minutes() : DefaultRangeTime.EndMin)
      .seconds(existingEndTime ? existingEndTime.seconds() : DefaultRangeTime.EndSec)
      .milliseconds(DefaultRangeTime.EndMs);
  }

  return [startTime ?? null, endTime ?? null];
};
